export default "__VITE_ASSET__CFI$8vlN__"